/**
 * Grid-aligned news counts for consistent row layouts.
 * COLS_2 → multiples of 2 | COLS_3 → multiples of 3
 */
export const GRID_COUNTS = {
	HOMEPAGE_LATEST: 4,
	TRENDING: 5,
	// RECOMMENDED: 6, // unused — homepage निवडक section not rendered
	CATEGORY_HERO_STORIES: 3,
	CATEGORY_PAGE_GRID: 3,
	EVERGREEN: 3,
	SUBCITIES: 3,
	RELATED: 3,
	LIST_PAGE: 12,
	MINI_TRENDING: 5,
	MOST_READ: 5,
	SIDEBAR_RECENT: 5,
}

/**
 * Trim items to complete grid rows (drops trailing orphans when row would be incomplete).
 * If fewer items than one full row, returns all available.
 */
export function forGrid(items = [], columns = 3) {
	if (!items?.length) return []

	const n = items.length
	if (n <= columns) return items.slice(0, n)

	const remainder = n % columns
	if (remainder === 0) return items

	return items.slice(0, n - remainder)
}

export function take(items = [], count) {
	if (!items?.length || count <= 0) return []
	return items.slice(0, Math.min(count, items.length))
}
